import * as api from "../api";

export const ContactService = {
    getContactList,
    createContactList,
    // addNumbersToContactList,
    // getContactListDetailsById,
    // changeContactListName,
    // getAllNumberForAContactList,
    // changeContactListStatus,
    // removeContactListNumbers,
    // getAllContactList
};

async function getContactList(formData, page, rowsPerPage) {
    try {
        const { data } = await api.getContactList(formData, page, rowsPerPage);
        return {isSuccess: true, data: data};
    } catch (error) {

        return {isSuccess: false, data: error};
    }
}

async function createContactList(formData) {
    try {
        const { data } = await api.createContactList(formData);
        return {isSuccess: true, data: data};
    } catch (error) {
        
        return {isSuccess: false, data: error};
    }
}

// async function addNumbersToContactList(formData) {
//     try {
//         const { data } = await api.addNumbersToContactList(formData);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }

// async function changeContactListName(formData) {
//     try {
//         const { data } = await api.changeContactListName(formData);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }

// async function removeContactListNumbers(formData) {
//     try {
//         const { data } = await api.removeContactListNumbers(formData);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }

// async function changeContactListStatus(formData) {
//     try {
//         const { data } = await api.changeContactListStatus(formData);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }

// async function getContactListDetailsById(formData) {
//     try {
//         const { data } = await api.getContactListDetailsById(formData);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }

// async function getAllNumberForAContactList(formData, page, rowsPerPage) {
//     try {
//         const { data } = await api.getAllNumberForAContactList(formData, page, rowsPerPage);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }

// async function getAllContactList(formData, page, rowsPerPage) {
//     try {
//         const { data } = await api.getAllContactList(formData, page, rowsPerPage);
//         return {isSuccess: true, data: data};
//     } catch (error) {

//         return {isSuccess: false, data: error};
//     }
// }
